export type SegOption<T extends string = string> = {
  value: T;
  label: string;
};

type SegRangeProps<T extends string = string> = {
  value: T;
  onChange: (value: T) => void;
  options: SegOption<T>[];
};

/**
 * Horizontal chip group — "All / Active / Paused" kind of picker.
 * Single-select, controlled.
 */
export function SegRange<T extends string = string>({
  value,
  onChange,
  options,
}: SegRangeProps<T>) {
  return (
    <div className="chip-group">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={value === o.value ? "active" : ""}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
